import { useEffect, useState } from 'react'
import { ApiUrl } from 'api/client'
import Styles from './DocStreamingContent.module.scss'
import EditorStyles from 'common/Prose/EditorRenderer/EditorRenderer.module.scss'
import cx from 'classnames'
import store from 'redux/store'
import { EditorView } from 'prosemirror-view'
import { StreamDocContentPluginKey } from 'common/Prose/Plugins/StreamDocContent/StreamDocContent'
import { ProsePreview } from 'common/ProsePreview/ProsePreview'
import { Fragment } from 'prosemirror-model'
import { schema, markdownParser } from 'prose-core'
import { ImagePreview } from 'common/Prose/nodeViews/Image/Image'
import { useReactNodeViewPortals } from 'common/Prose/nodeViews/ReactNodeView/ReactnodeViewPortalsContext'
import { reactNodeViewFactory } from 'common/Prose/nodeViews/utils/reactNodeViewFactory'

export const DocStreamingContent = ({ generationId, view }: { generationId: string; view: EditorView }) => {
  const [aiText, setAIText] = useState('')
  const [isStreaming, setIsStreaming] = useState(false)
  const { headers } = store.getState()
  const { createPortal, removePortal } = useReactNodeViewPortals()
  const makeReactNodeViewFn = reactNodeViewFactory(createPortal, removePortal, false)

  useEffect(() => {
    ;(async () => {
      const streamResponse = await fetch(`${ApiUrl}/stream-generation?job_id=${generationId}`, {
        method: 'GET',
        headers: {
          ...headers,
          'Content-Type': 'application/json',
        },
      })
      if (!streamResponse.body || streamResponse.status !== 200) return
      setIsStreaming(true)
      const reader = streamResponse.body.getReader()
      const decoder = new TextDecoder('utf-8')
      let done = false
      let value
      while (!done) {
        ;({ done, value } = await reader.read())
        if (done) {
          const tr = view.state.tr
          tr.setMeta(StreamDocContentPluginKey, { action: 'done' })
          setIsStreaming(false)
          break
        }

        let chunk = decoder.decode(value)
        const lines = chunk.split('\n')
        const parsedLines = lines.flatMap((line) => {
          line = line.replace(/^data: /, '')
          line = line.replace(/\\n/g, '\n')
          if (line === '' || line === '[DONE]') return null

          return line
        })

        parsedLines.forEach((line) => {
          if (!line || line === '[DONE]') return

          setAIText((aiText) => aiText + line)
        })
      }
    })()
    return () => {}
  }, [generationId]) // eslint-disable-line react-hooks/exhaustive-deps

  if (!isStreaming) return null

  const wrappedNode = markdownParser.parse(aiText)

  return (
    <div className={Styles.wrapper}>
      <div className={cx(EditorStyles.editorRenderer, 'prosemirror-editor')}>
        <ProsePreview
          nodes={wrappedNode?.content || Fragment.empty}
          schema={schema}
          nodeViews={{
            image: makeReactNodeViewFn(ImagePreview),
          }}
        />
      </div>
    </div>
  )
}
